import { ApplicantBeneficialOwnersStepView } from "./applicant-beneficial-owner-step-view";
import { useApplicantBeneficialOwnerStep } from "./use-applicant-beneficial-owner-step";

export default function ApplicantBeneficialOwnersStep() {
  const logic = useApplicantBeneficialOwnerStep();
  return <ApplicantBeneficialOwnersStepView {...logic} />;
}
